import React, {createContext, useContext, useState, ReactNode} from 'react'

type TooltipData = {
  visible: boolean
  content: ReactNode
}

type TooltipsMap = Record<string, TooltipData>

type TooltipContextType = {
  tooltips: TooltipsMap
  showTooltip: (containerName: string, content: ReactNode) => void
  hideTooltip: (containerName: string) => void
}

const TooltipContext = createContext<TooltipContextType | null>(null)

type TooltipProviderProps = {
  children: ReactNode
}

export function RemoteTooltipProvider({children}: TooltipProviderProps) {
  const [tooltips, setTooltips] = useState<TooltipsMap>({})

  const showTooltip = (containerName: string, content: ReactNode) => {
    setTooltips((prev) => ({
      ...prev,
      [containerName]: {visible: true, content},
    }))
  }

  const hideTooltip = (containerName: string) => {
    setTooltips((prev) => ({
      ...prev,
      [containerName]: {
        ...prev[containerName],
        visible: false,
      },
    }))
  }

  return (
    <TooltipContext.Provider value={{tooltips, showTooltip, hideTooltip}}>
      {children}
    </TooltipContext.Provider>
  )
}

export function useTooltip(): TooltipContextType {
  const ctx = useContext(TooltipContext)
  if (!ctx) {
    throw new Error('useTooltip must be used inside RemoteTooltipProvider')
  }
  return ctx
}
